<header class="main-header">
  <div class="header-content">
    <!-- Left Section -->
    <div class="header-left">
      <button class="menu-toggle" (click)="onToggleSidebar()" aria-label="Toggle sidebar">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 5H17M3 10H17M3 15H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Center Section - Search -->
    <div class="header-center">
      <div class="search-box" [class.has-results]="showSearchResults">
        <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M19 19L14.65 14.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>

        <input type="text" placeholder="Search leads, clients, opportunities, tasks..." [(ngModel)]="searchQuery"
          (input)="onSearchInput($event)" (focus)="onSearchFocus()" (blur)="onSearchBlur()">

        <!-- Loading spinner -->
        <div class="search-spinner" *ngIf="isSearching">
          <div class="spinner-small"></div>
        </div>

        <!-- Clear button -->
        <button class="search-clear" *ngIf="searchQuery" (click)="clearSearch()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>

        <!-- Search Results Dropdown -->
        <div class="search-results" *ngIf="showSearchResults" @slideIn>
          <div class="results-list">
            <div class="result-item" *ngFor="let result of searchResults; trackBy: trackByResultId"
              (mousedown)="onResultClick(result)" [class]="'result-' + getResultTypeColor(result.type)">

              <div class="result-icon">
                <ng-container [ngSwitch]="result.type">

                  <!-- Lead -->
                  <svg *ngSwitchCase="'Lead'" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>

                  <!-- Client -->
                  <svg *ngSwitchCase="'Client'" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" />
                  </svg>

                  <!-- Opportunity -->
                  <svg *ngSwitchCase="'Opportunity'" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 
               1.18 6.88L12 17.77l-6.18 3.25L7 14.14 
               2 9.27l6.91-1.01L12 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>

                  <!-- Task -->
                  <svg *ngSwitchCase="'Task'" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 
               4.03-9 9-9c2.39 0 4.68.94 6.36 2.64" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>

                  <!-- Default / Search -->
                  <svg *ngSwitchDefault width="16" height="16" viewBox="0 0 20 20" fill="none">
                    <path d="M9 17C13.4183 17 17 13.4183 17 9
               C17 4.58172 13.4183 1 9 1
               C4.58172 1 1 4.58172 1 9
               C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M19 19L14.65 14.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>

                </ng-container>
              </div>


              <div class="result-content">
                <div class="result-name">{{ result.name }}</div>
                <div class="result-context">{{ result.context }}</div>
              </div>

              <div class="result-type">{{ result.type }}</div>
            </div>
          </div>

          <div class="no-results" *ngIf="!isSearching && searchResults.length === 0 && searchQuery.length >= 2">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
                stroke="currentColor" stroke-width="2" />
              <path d="M19 19L14.65 14.65" stroke="currentColor" stroke-width="2" />
            </svg>
            <span>No results found</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Section -->
    <div class="header-right">
      <!-- Branch Selector -->
      <div class="branch-selector-wrapper" *ngIf="authService.currentUser()">
        <!-- Dropdown for multiple branches -->
        <ng-container *ngIf="branchContext.availableBranches().length > 1">
          <label for="branch-select">Branch</label>
          <select id="branch-select" [ngModel]="selectedBranch" (ngModelChange)="onBranchChange($event)">
            <option [value]="null">All Branches</option>
            <option *ngFor="let branch of branchContext.availableBranches()" [value]="branch.id">
              {{ branch.name }}
            </option>
          </select>
        </ng-container>

        <!-- Static display for single branch -->
        <ng-container *ngIf="branchContext.availableBranches().length === 1">
          <span class="static-branch">{{ branchContext.availableBranches()[0].name }}</span>
        </ng-container>
      </div>

      <!-- Notifications -->
      <app-notification-dropdown></app-notification-dropdown>
    </div>
  </div>
</header>